import React from "react";
import "./FullPageFilterForm.scss";

const FullPageFilterForm: React.FC = ({ children }) => (
  <div className="full-page-filter-form">{children}</div>
);

export default FullPageFilterForm;
